import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import pushNotification from './slices/pushNotificationSlice';
import faq from './slices/faqSlice';

import coach from './slices/coachSlice';
import parent from './slices/parentSlice';
import player from './slices/playerSlice';
import group from './slices/groupSlice';
import session from './slices/sessionSlice';
import category from './slices/categorySlice';
import sport from './slices/sportSlice';
import club from './slices/clubSlice';
import subscription from './slices/subscriptionSlice';

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        coach,
        parent,
        player,
        group,
        session,
        category,
        sport,
        club,
        subscription,
        theme,
        auth,
        pushNotification,
        faq,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
